export default __webpack_public_path__ + "static/media/Homepage-Destinations-image-size-370_370-Pachmarhi.0d459081.png";